import fecha from 'fecha';
import { PLATFORM_DATE_FORMAT } from './constants';
export var parseDateString = function (dateString, fromFormat) {
  if (fromFormat === void 0) {
    fromFormat = PLATFORM_DATE_FORMAT;
  }
  if (!dateString) {
    return null;
  }
  return fecha.parse(dateString, fromFormat);
};